<template>
  <page-error
    v-if="loyaltyProvisionFailed"
    :message="$t('Something_Went_Wrong_Message')"
  />
  <rest-page
    v-else
    ref="restPage"
    :fetch-endpoint="fetchEndpoint"
    class="page-ct"
    @on-error="handleRestPageError()"
  >
    <loyalty-frame v-if="isLoyaltyAvailable" :domain="domain" />
    <div v-loading="!isLoyaltyAvailable" style="height: 100%" v-else />
  </rest-page>
</template>

<script>
import LoyaltyFrame from '@/modules/gamification/components/loyalty/LoyaltyFrame.vue'
import RestPage from '@/common/components/rest/RestPage.vue'
import { $hasFeature } from '@/core/utils/VueAcl'
import RestApi from '@/core/services/RestApi'
import { projectEndpoint } from '@/core/helpers'
import PageError from '@/common/components/page/PageError.vue'

export default {
  name: 'GamesHubLoyalty',
  components: { PageError, RestPage, LoyaltyFrame },
  data() {
    return {
      domain: '',
      poller: null,
      loyaltyStatus: false,
      loyaltyProvisionFailed: false
    }
  },
  computed: {
    projectId() {
      return this.$route.query.project_id
    },
    fetchEndpoint() {
      if (!this.isLoyaltyAvailable) {
        return this.fetchLoyaltyDashboardStatusEndpoint
      }
      return this.fetchDomainEndpoint
    },
    loyaltyProjectFeatureEnabled() {
      return $hasFeature('loyalty')
    },
    loyaltyProjectDashboardAvailable() {
      return $hasFeature('loyalDashboardAvailable')
    },
    isLoyaltyAvailable() {
      return (
        (this.loyaltyProjectFeatureEnabled &&
          this.loyaltyProjectDashboardAvailable) ||
        this.loyaltyStatus
      )
    },
    fetchDomainEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: `loyalty/loyalty-dashboard-domain`,
        handler: data => {
          this.domain = data
        }
      })
    },
    fetchLoyaltyDashboardStatusEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: `loyalty/domain-status`,
        handler: data => {
          if (data.status === 'deployed') {
            this.loyaltyStatus = true
          }

          if (data.status === 'failed') {
            this.loyaltyStatus = false
            this.loyaltyProvisionFailed = true
            this.stopPolling()
            return
          }

          if (this.loyaltyStatus) {
            this.$nextTick(() => {
              if (this.$refs.restPage) {
                this.$refs.restPage.reload()
              }
            })
            this.stopPolling()
          }

          if (!this.loyaltyStatus && !this.loyaltyProvisionFailed) {
            if (!this.poller) {
              this.startPolling()
            }
          }
        }
      })
    }
  },
  methods: {
    startPolling() {
      if (this.poller) return
      this.poller = setInterval(this.fetchLoyaltyStatus, 10000)
    },
    fetchLoyaltyStatus() {
      const endpoint = this.fetchLoyaltyDashboardStatusEndpoint
      RestApi(endpoint)
        .then(({ data }) => {
          endpoint.handler(data)
        })
        .catch(error => {
          this.stopPolling()
          this.$message({
            message: error.message,
            type: 'error'
          })
        })
    },
    stopPolling() {
      if (!this.poller) {
        return
      }
      clearInterval(this.poller)
      this.poller = null
    },
    handleRestPageError() {
      this.stopPolling()
    }
  },
  beforeDestroy() {
    this.stopPolling()
    if (!$hasFeature('loyalDashboardAvailable') && this.loyaltyStatus) {
      this.$store.dispatch('reloadProjectConfig')
    }
  }
}
</script>

<style scoped>
.page-ct {
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/modules/gamification/pages/GamesHubLoyaltyPage.vue